import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_PricecategoryListComponent from "../components/_FM_pricecategory/_FM_PricecategoryListComponent";
import _FM_PricecategoryFormComponent from "../components/_FM_pricecategory/_FM_PricecategoryFormComponent";
import _FM_PricecategoryShowComponent from "../components/_FM_pricecategory/_FM_PricecategoryShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_PricecategoryPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {entity, id, action} = useParams();

  useEffect(() => {
    document.title = t('pricecategory') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/price-category')
  }, []);

  useEffect(() => {

  }, []);

  return (
    <div className="_FM_PricecategoryPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/price-category"}/>
      <Panel>
        <_FM_PricecategoryListComponent/>
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/price-category');
               }}>
        <_FM_PricecategoryFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/price-category');
               }}>
        <_FM_PricecategoryShowComponent/>
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_PricecategoryPage);
